import { ApiCallConfig } from '@/lib/types';
import axios from 'axios';
import { getSession } from 'next-auth/react';

export async function authApiCall(url: string, config?: ApiCallConfig) {
  const apiUrl = `/api/${url}`;
  const session = await getSession();
  if (!session) throw new Error('Unauthenticated');
  try {
    return axios.request({
      url: apiUrl,
      method: config?.method ?? 'GET',
      withCredentials: true,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...config?.config?.headers,
      },
      ...config?.config,
    });
  } catch (e) {
    console.error(`Error with call to - ${url}.`);
    console.error(e);
  }
}

export async function recallAiApiRequest(
  apiUrlSegment: string,
  config: ApiCallConfig,
) {
  const url = `https://${process.env.RECALLAI_REGION}.recall.ai/api/v1/${apiUrlSegment}`;
  try {
    return axios.request({
      url: url,
      method: config.method,
      headers: {
        Authorization: `Token ${process.env.RECALLAI_API_KEY}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...config.config?.headers,
      },
      ...config.config,
    });
  } catch (e) {
    console.error(`Error with Recall.Ai call to - ${apiUrlSegment}.`);
    console.error(e);
  }
}
